import { API } from '../Api';
import type { AdminRatingRow } from './brand-deal.api';

// Hồ sơ đánh giá hợp tác (spec 2026-10-12 §4). `auid` do gateway gắn từ JWT, KHÔNG truyền từ FE.
// - Hồ sơ creator: công khai, không cần đăng nhập  -> /v1/payment-service/public/brand-profiles/*
// - Hồ sơ người đặt: cần đăng nhập                   -> /v1/payment-service/brand-profiles/*
// - Trả lời: creator dưới brand-deals, người đặt dưới brand-campaigns; admin ẩn/bỏ ẩn dưới admin/brand-ratings.
const PUBLIC_BASE = '/v1/payment-service/public/brand-profiles';
const BASE = '/v1/payment-service/brand-profiles';
const DEALS_BASE = '/v1/payment-service/brand-deals';
const CAMPAIGNS_BASE = '/v1/payment-service/brand-campaigns';
const ADMIN_BASE = '/v1/payment-service/admin/brand-ratings';

export interface BrandProfileMetrics {
  average: number | null;
  ratingCount: number;
  completedDeals: number;
  /** 0–100; null khi chưa có lần nào tính được. */
  onTimePercent: number | null;
  onTimeBase: number;
  disputesLost: number;
}

export interface BrandCreatorProfile {
  userId: string;
  /** false: không hiện tab "Hợp tác". */
  visible: boolean;
  joinedAt: string | null;
  ratingCount: number;
  /** null: "Chưa đủ dữ liệu". */
  metrics: BrandProfileMetrics | null;
}

export interface BrandOrdererProfile {
  adAccountId: string;
  name: string;
  kind: 'Business' | 'Individual';
  verified: boolean;
  isOwner: boolean;
  joinedAt: string | null;
  ratingCount: number;
  metrics: BrandProfileMetrics | null;
}

export interface BrandRatingReply {
  text: string;
  createdAt: string;
}

export interface BrandProfileReview {
  id: string;
  stars: number;
  comment: string | null;
  campaignTitle: string;
  createdAt: string;
  raterName: string;
  reply: BrandRatingReply | null;
  /** Chỉ trang người đặt tính sẵn; trang creator công khai luôn false, FE tự so người xem. */
  canReply: boolean;
}

export interface BrandProfileReviewPage {
  items: BrandProfileReview[];
  page: number;
  hasMore: boolean;
}

export const getCreatorBrandProfile = (userId: string) =>
  API.get<BrandCreatorProfile>(`${PUBLIC_BASE}/creators/${userId}`).then((r) => r.data);

export const getCreatorBrandReviews = (userId: string, page = 1) =>
  API.get<BrandProfileReviewPage>(`${PUBLIC_BASE}/creators/${userId}/reviews`, { params: { page } }).then((r) => r.data);

export const getOrdererBrandProfile = (adAccountId: string) =>
  API.get<BrandOrdererProfile>(`${BASE}/orderers/${adAccountId}`).then((r) => r.data);

export const getOrdererBrandReviews = (adAccountId: string, page = 1) =>
  API.get<BrandProfileReviewPage>(`${BASE}/orderers/${adAccountId}/reviews`, { params: { page } }).then((r) => r.data);

export const replyToCreatorRating = (ratingId: string, text: string) =>
  API.post<BrandRatingReply>(`${DEALS_BASE}/ratings/${ratingId}/reply`, { text }).then((r) => r.data);

export const replyToOrdererRating = (ratingId: string, text: string) =>
  API.post<BrandRatingReply>(`${CAMPAIGNS_BASE}/ratings/${ratingId}/reply`, { text }).then((r) => r.data);

/** Ẩn — lý do 5–300 ký tự + mã Authenticator. */
export const adminHideBrandRating = (ratingId: string, reason: string, totpCode: string) =>
  API.post<AdminRatingRow>(`${ADMIN_BASE}/${ratingId}/hide`, { reason }, { params: { totpCode } }).then((r) => r.data);

/** Bỏ ẩn — mã Authenticator. */
export const adminUnhideBrandRating = (ratingId: string, totpCode: string) =>
  API.post<AdminRatingRow>(`${ADMIN_BASE}/${ratingId}/unhide`, null, { params: { totpCode } }).then((r) => r.data);
